// SPDX-License-Identifier: AGPL-3.0-or-later

const hasWindow = typeof window !== 'undefined';
const hasNavigator = typeof navigator !== 'undefined';
const userAgent = hasNavigator ? navigator.userAgent : '';
const isIOSDevice = /iPad|iPhone|iPod/i.test(userAgent);
const isAndroidDevice = /Android/i.test(userAgent);
const isElectron =
	hasWindow &&
	(
		window as {
			electron?: unknown;
		}
	).electron !== undefined;
const isIOSWeb = isIOSDevice && !isElectron;
const isPWA =
	(hasWindow && window.matchMedia?.('(display-mode: standalone)').matches) ||
	(hasNavigator &&
		(
			navigator as {
				standalone?: boolean;
			}
		).standalone === true);
const isMobileBrowser = isIOSDevice || isAndroidDevice;

export const Platform = {
	isElectron,
	isIOSWeb,
	isPWA,
	isMobileBrowser,
};

export function getNativeLocaleIdentifier(): string | null {
	if (typeof navigator === 'undefined') {
		return null;
	}
	const languages = navigator.languages;
	if (Array.isArray(languages) && languages.length > 0) {
		return languages[0];
	}
	return navigator.language ?? null;
}
